import { onlineManager } from '@tanstack/react-query';
import productActionsRepositoryOfflineAdapters from '../../../offline/offlineRequestAdapters/productActions.repository.offlineAdapters';
import { onlineProductActionRepository } from './onlineProductActions.repository';

export const productActionsRepository = () =>
  onlineManager.isOnline()
    ? onlineProductActionRepository
    : productActionsRepositoryOfflineAdapters;
